import request from '../untils/request.js'

// 本地最新新闻
export const getMas = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/groupNews/getIndustryNews',
            params
        })
    }
    //热点新闻
export const boot = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/hotNews/getTodayHotNews',
        params
    })
}

//科技新闻
export const word = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/hotNews/getHotNews',
            params
        })
    }
    //热点新闻 -酒泉
export const getJiuQuanHotNews = () => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/hotNews/getJiuQuanHotNews',

        })
    }
    // 集团新闻
export const getNews = () => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/groupNews/getNews',
        })
    }
    // 消防新闻
export const getFireNews = () => {
        return request({
            method: 'GET',
            url: 'lsg-bigscreen/groupNews/getFireNews',
        })
    }
    // 城市区域码
export const getMap = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/newsMap/getNewsByCity',
            params
        })
    }
    // 本地新闻热点
export const monRe = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/localNews/getLocalHotNews',
            params
        })
    }
    // 新闻热词
export const hotNum = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/localNews/getHotWord',
            params
        })
    }
    // 本地新闻数量
export const setNum = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/localNews/getNewsCount',
            params
        })
    }
    // 两微汇聚新闻
export const TwoCont = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/lwhj/getNews',
            params
        })
    }
    //两微汇聚热点
export const TwoEve = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/lwhj/getHotNews',
            params
        })
    }
    //两微汇聚新闻数量
export const Twonum = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/lwhj/getNewsCount',
            params
        })
    }
    //领导人
export const getLeader = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/leader/getLeader',
            params
        })
    }
    //领导人信息接口
export const getLeaderById = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/leader/getLeaderById',
            params
        })
    }
    //上传领导人图片接口
export const upload = data => {
        return request({
            method: 'POST',
            url: '/lsg-bigscreen/leader/upload',
            data
        })
    }
    //视频汇聚
export const getConvergence = data => {
        return request({
            method: 'post',
            url: '/lsg-bigscreen/videoSum/queryContent',
            data
        })
    }
    //视频汇聚 宣传片
export const monvideo = data => {
    return request({
        method: 'POST',
        url: '/lsg-bigscreen/trailerBackEnd/getTrailerList',
        data
    })
}
